import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Button } from '../../Controls/Button/index.js';
import Icons from '../../Elements/Icons/index.js';
import { Wrapper, Title, Text } from './styled.js';
const UpdateBanner = ({ title, text, onReload, dataTestId }) => (_jsxs(Wrapper, { children: [_jsxs("div", { children: [_jsx(Title, { children: title }), text && _jsx(Text, { children: text })] }), _jsx(Button, { primary: true, iconOnly: true, onClick: onReload, "data-testid": dataTestId, children: _jsx(Icons.Reload, { size: 20 }) })] }));
export default React.memo(UpdateBanner);
